// import getcomponent from "./verification.js"
// import i18n from "../assets/language/index.js"


export default [{ //登录
    path: '/login',
    component: (resolve) => {
        require(['../view/user/login/longin.vue'], resolve)
    },
    name: 'login',
}, { //注册
    path: '/register',
    component: (resolve) => {
        require(['../view/user/login/register.vue'], resolve)
    },
    name: 'loginregister',

}, { //忘记密码
    path: '/forgotpassword',
    component: (resolve) => {
        require(['../view/user/login/forget.vue'], resolve)
    },
    name: 'password',

}, { //BolyService博立条款
    path: '/BolyService',
    component: (resolve) => {
        require(['../view/user/login/BolyService.vue'], resolve)
    },
    name: 'BolyService',
}, {
    path: '/',
    component: (resolve) => {
        require(['../view/user/layout/index.vue'], resolve)
    },
    name: 'layout',
    redirect: '/index',
    children: [{ // 首页
        path: 'index',
        component: (resolve) => {
            require(['../view/user/home/index.vue'], resolve)
        },
        name: 'index',
        meta: {
            islogin: true, //是否登录
            Highlight: 1, //导航高亮（1index/2camera/3personl/4about）
        },
    }, { //相机-------------------------------------------
        path: 'camera',
        component: (resolve) => {
            require(['../view/user/camera/cameraList.vue'], resolve)
        },
        name: 'cameraList',
        meta: {
            islogin: true, //是否登录
            Highlight: 2, //导航高亮（1index/2camera/3personl/4about）
            choosename: "camera", //手机底部导航高亮（camera/register/personal）
            phontitle: "message.navigation.Camera",
        },
    }, { //注册相机
        path: 'camera/register',
        component: (resolve) => {
            require(['../view/user/camera/register.vue'], resolve)
        },
        name: 'register',
        meta: {
            islogin: true, //是否登录
            Highlight: 2, //导航高亮（1index/2camera/3personl/4about）
            choosename: "register", //手机底部导航高亮（camera/register/personal）
            phontitle: "message.navigation.Registercamera",
        },
    }, { //图片内容
        path: 'details',
        component: (resolve) => {
            require(['../view/user/camera/details/index.vue'], resolve)
        },
        name: 'details',
        redirect: 'details/files',
        children: [{ //文件列表
            path: ':state',
            component: (resolve) => {
                require(['../view/user/camera/details/cameraFile.vue'], resolve)
            },
            name: 'cameraFiles',
            meta: {
                islogin: true, //是否登录
                Highlight: 2, //导航高亮（1index/2camera/3personl/4about）
                choosename: "camera", //手机底部导航高亮（camera/register/personal）
                phontitle: "message.navigation.document",
            },
        }]
    }, { //个人中心
        path: 'personal',
        component: (resolve) => {
            require(['../view/user/personal/index.vue'], resolve)
        },
        name: 'personal',
        meta: {
            islogin: true, //是否登录
            Highlight: 3, //导航高亮（1index/2camera/3personl/4about）
            choosename: "personal", //手机底部导航高亮（camera/register/personal）
            phontitle: "message.navigation.personal",
        },
    }, { //关于我们
        path: 'about',
        component: (resolve) => {
            require(['../view/user/about/index.vue'], resolve)
        },
        name: 'about',
        meta: {
            islogin: true, //是否登录
            Highlight: 4, //导航高亮（1index/2camera/3personl/4about）
            // phontitle: "message.navigation.personal",
        },
    }]
}];


// WEBPACK FOOTER //
// ./src/router/user.js